import './App.css';
import SecretSanta from './components/SecretSantaComponent';

function App() {
    return (
        <div className="App">
            <SecretSanta />
        </div>
    );
}

export default App;
